import { render, staticRenderFns } from "./automation-type.vue?vue&type=template&id=c5cd3124"
import script from "./automation-type.vue?vue&type=script&lang=js"
export * from "./automation-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports